import { Injectable } from '@angular/core';
import { Headers } from '@angular/http';

@Injectable()
export class HttpUtilityService {

    buildUrl(pathAndParameters: string): string {
        return null;
    }

    getUrl(path: string): string {
        return null;
    }

    getHeaders(): Headers {
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/http-utility.service.ts